/* stylelint-disable selector-class-pattern, max-nesting-depth, comment-empty-line-before, declaration-block-no-redundant-longhand-properties */
/**
 * @prop --wf-loyalty-points-price-padding-y: The padding on the y-axis for the inner content.
 * @prop --wf-loyalty-points-price-padding-x: The padding on the x-axis for the inner content.
 * @prop --wf-loyalty-gold-100: The background color of the card.
 * @prop --wf-loyalty-grey-1000: The color of the footer text.
 * @prop --wf-loyalty-small-font-size: The font size of the main information.
 * @prop --wf-loyalty-gold-800: The color of the points additions.
 * @prop --wf-loyalty-caps-font-size: The font size of the CTA.
 */
:host {
    padding: var(--wf-loyalty-points-price-padding-x, 12px)
        var(--wf-loyalty-points-price-padding-x, 12px);

    background: var(--wf-loyalty-gold-100, #f2e6d8);

    display: flex;
    flex-direction: column;
    gap: 12px;

    .loyalty-point-earn {
        color: var(--wf-loyalty-grey-1000, #000);
        font-weight: 500;
        font-size: var(--wf-loyalty-caps-font-size, 14px);

        display: flex;
        flex-direction: row;
        gap: 12px;

        align-items: center;

        img {
            width: 24px;
            height: 24px;
        }

        .loyalty-point-earn-info {
            margin: 0;
            padding: 0;

            .highlight {
                color: var(--wf-loyalty-gold-800, #875f31);
                font-weight: 800;
            }
        }
    }

    .loyalty-cta {
        display: block;
        align-content: center;
    }
}

:host(.has-cta) {
    background-position: left top;

    .loyalty-point-earn {
        img {
            width: 40px;
            height: 40px;
        }
    }
}

:host(.is-skeleton) {
    --wf-loyalty-skeleton-color: var(--wf-loyalty-gold-200, #e0ccb4);

    position: relative;
    overflow: hidden;
    background-color: var(--wf-loyalty-gold-100, #f2e6d8);

    &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transform: translateX(-100%);
        background-image: linear-gradient(
            90deg,
            rgba(#fff, 0) 0,
            rgba(#fff, 0.2) 20%,
            rgba(#fff, 0.5) 60%,
            rgba(#fff, 0)
        );
        animation: shimmer 5s infinite;
        content: "";
    }

    @keyframes shimmer {
        100% {
            transform: translateX(100%);
        }
    }

    .loyalty-point-earn {
        .loyalty-point-earn-info {
            color: var(--wf-loyalty-skeleton-color);
            background-color: var(--wf-loyalty-skeleton-color);

            .highlight {
                color: var(--wf-loyalty-skeleton-color);
            }
        }
    }

    .loyalty-cta {
        background-color: var(--wf-loyalty-skeleton-color);
        border-color: var(--wf-loyalty-skeleton-color);
        color: var(--wf-loyalty-skeleton-color) !important;

        display: none;
    }
}

@media screen and (min-width: 768px) {
    :host {
        padding: var(--wf-loyalty-points-price-padding-x, 12px)
            var(--wf-loyalty-points-price-padding-x, 12px);

        flex-direction: row;
        gap: 12px;
    }
}
